import {type AutomaticBillingDate} from 'web-app/util/graphql/api-types';
import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/AUTOMATIC_PAYMENTS';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (
        institutionSetId: string,
        paymentsAccountId: string,
        isAutomaticPaymentsByDefault: boolean,
        nextAutomaticPaymentDate: string,
        setNextAutomaticPayments: (date: Array<string> | null) => void,
        setAutomaticBillingDate: (automaticBillingDate: AutomaticBillingDate | null) => void,
        canUseExactDayOfWeek: boolean,
    ) => ({
        institutionSetId,
        paymentsAccountId,
        isAutomaticPaymentsByDefault,
        nextAutomaticPaymentDate,
        setNextAutomaticPayments,
        setAutomaticBillingDate,
        canUseExactDayOfWeek,
    }),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
